export const BROADCAST_CHANNELS = {
  AUTH: 'auth_channel',
} as const;

export const BROADCAST_MESSAGES = {
  LOGOUT: 'logout',
  WINDOW_RELOAD: 'window_reload',
} as const;
